import { getActions } from '../global';

import type { LeadRecord, QuickReplyItem } from './crmStorage';

import { createSignal } from '../util/signals';
import { getStoredQuickReplies } from './crmStorage';

function closeRightColumnIfOpen() {
  try {
    getActions().setShouldCloseRightColumn({ value: true });
  } catch (err) {
    // Actions might not be initialized yet
  }
}

export const [getIsCrmDrawerOpen, setIsCrmDrawerOpen] = createSignal(false);
export const [getSelectedChatLead, setSelectedChatLead] = createSignal<LeadRecord | undefined>(undefined);

export function toggleCrmDrawer() {
  const willOpen = !getIsCrmDrawerOpen();
  if (willOpen) {
    setIsQuickRepliesDrawerOpen(false);
    closeRightColumnIfOpen();
  }
  setIsCrmDrawerOpen(willOpen);
}

export function openCrmDrawer() {
  setIsQuickRepliesDrawerOpen(false);
  closeRightColumnIfOpen();
  setIsCrmDrawerOpen(true);
}

export function closeCrmDrawer() {
  setIsCrmDrawerOpen(false);
}

export const [getIsQuickRepliesDrawerOpen, setIsQuickRepliesDrawerOpen] = createSignal(false);
export const [getQuickReplies, setQuickReplies] = createSignal<QuickReplyItem[]>(getStoredQuickReplies());

export function toggleQuickRepliesDrawer() {
  const willOpen = !getIsQuickRepliesDrawerOpen();
  if (willOpen) {
    setIsCrmDrawerOpen(false);
    closeRightColumnIfOpen();
  }
  setIsQuickRepliesDrawerOpen(willOpen);
}

export function openQuickRepliesDrawer() {
  setIsCrmDrawerOpen(false);
  closeRightColumnIfOpen();
  setIsQuickRepliesDrawerOpen(true);
}

export function closeQuickRepliesDrawer() {
  setIsQuickRepliesDrawerOpen(false);
}

if (typeof window !== 'undefined') {
  window.addEventListener('crm:quick-replies-changed', ((e: CustomEvent<QuickReplyItem[]>) => {
    if (e.detail) {
      setQuickReplies(e.detail);
    }
  }) as EventListener);
}

export type ChatTypeFilter = 'all' | 'unanswered' | 'groups' | 'channels';
export const [getChatTypeFilter, setChatTypeFilter] = createSignal<ChatTypeFilter>('all');

export interface UnansweredSummary {
  total: number;
  urgent: number;
}
export const [getUnansweredSummary, setUnansweredSummary] = createSignal<UnansweredSummary>({ total: 0, urgent: 0 });

export const [getSlaTick, setSlaTick] = createSignal<number>(Date.now());

if (typeof window !== 'undefined') {
  window.setInterval(() => {
    setSlaTick(Date.now());
  }, 30000);
}

export function formatElapsedTime(seconds: number): string {
  const minutes = Math.max(0, Math.floor(seconds / 60));
  if (minutes < 60) {
    return `${minutes}m`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
}
